<template lang="pug">
.container-anexo.clearfix
  p.label {{ documento.nome }} &nbsp
    i.fal.fa-file
  el-button.download-button(type="text", @click="baixarDocumento(documento.id)")
    i.fa.fa-download
</template>
<script>
import { mapActions } from 'vuex'

export default {
  props: {
    documento: {
      Type: Object,
      required: true
    }
  },
  methods: {
    ...mapActions({
      baixarDocumento: 'usuario/downloadDocumentoAlteracao'
    })
  }
}
</script>
<style lang="scss" scoped>
.container-anexo {
  width: 100%;
  border: 1px solid #000;
  padding: 0 10px;
  border-radius: 3px;
}

.label {
  margin-top: 10px;
  display: inline-block;
}

.file-icon {
  margin-left: 10px;
  font-size: 1rem;
}

.download-button {
  float: right;
  color: #555;
}

</style>



// WEBPACK FOOTER //
// src/components/AppDownloadAnexo.vue